(function() {
    'use strict';
    /* globals SockJS, Stomp */

    angular
        .module('quantixApp')
        .factory('PortfolioTrackerService', PortfolioTrackerService);

    PortfolioTrackerService.$inject = ['$rootScope', '$window', '$http', '$q'];

    function PortfolioTrackerService ($rootScope, $window, $http, $q) {
    	
    	
    	var _getPortfolioTrackerInfo = function(searchText) {

			var deferred = $q.defer();
			var url = 'api/adminScreen/getPortfolioUsageReportList';

			$http.post(url,searchText).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
			}
    	
    	var _getClientList = function() {

			var deferred = $q.defer();
			var url = 'api/RRCRRReport/getClientNameList';

			$http.post(url).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
			}
    	
    	var _getFSMClientList = function() {

			var deferred = $q.defer();
			var url = 'api/adminScreen/getFSMClientAndComp';

			$http.post(url).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
			}
    	
    	
    	return {
    		getPortfolioTrackerInfo : _getPortfolioTrackerInfo,
    		getClientList : _getClientList,
    		getFSMClientList : _getFSMClientList
		
		};
    }
})();
